import { schedulePostCommitTask } from './context';
export function createPostCommitSubscribers(getValue) {
    const subscribers = new Map();
    let revision = 0;
    const flush = () => {
        if (subscribers.size === 0) {
            return;
        }
        const currentRevision = revision;
        const value = getValue();
        for (const [subscriber, seenRevision] of Array.from(subscribers.entries())) {
            if (seenRevision >= currentRevision) {
                continue;
            }
            subscribers.set(subscriber, currentRevision);
            subscriber(value);
        }
    };
    return {
        subscribe(fn) {
            subscribers.set(fn, revision);
            fn(getValue());
            return () => {
                subscribers.delete(fn);
            };
        },
        notify() {
            revision += 1;
            if (subscribers.size > 0) {
                schedulePostCommitTask(flush);
            }
        },
    };
}
//# sourceMappingURL=subscriptions.js.map